export function debugConsole(...log) {
  if (process.env.NX_APP_ENV !== 'prod') {
    // eslint-disable-next-line no-console
    console.log(...log);
  }
}

/**
 * Sentry会记录相关的log信息，所以console.log其实是必要的
 * use destruct make eslint happy
 */
export const Log = console;

export function isFunction(obj: any) {
  return typeof obj === 'function';
}

/**
 * 获取url参数
 * @param  {string} name 参数名
 * @return {string} 参数值
 */
export function getUrlParam(name) {
  const url = window.location.search.split('#')[0];
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const res = url.substr(1).match(reg);
  if (res !== null) {
    return decodeURIComponent(res[2]);
  }
  return null;
}

/**
 * 将url中的querystring转换为object
 * @param  {String} url 如：a.com/b?c=d&e 或者 a=b&c=
 * @return {Object}     如：{c:'d',e:''}  或者 {a:'b',c:''}
 */
export function parseQuery(url = window.location.search, emptyValue = '') {
  let arr;
  if (url.includes('#')) {
    arr = url.split('#')[0].split('?');
  } else {
    arr = url.split('?');
  }
  const queryString = arr[arr.length - 1];
  const entrys = queryString === url ? [] : queryString.split('&');
  const res: Record<string, string> = {};
  for (let i = 0; i < entrys.length; i++) {
    const entry = entrys[i];
    const arr1 = entry.split('=');

    if (arr1[0]) {
      res[decodeURIComponent(arr1[0])] = decodeURIComponent(
        arr1[1] || emptyValue
      );
    }
  }

  return res as Record<string, string>;
}

/**
 * Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
 *
 * @type boolean
 */
export const deviceIsWindowsPhone =
  navigator.userAgent.indexOf('Windows Phone') >= 0;

/**
 * iOS requires exceptions.
 *
 * @type boolean
 */
export const deviceIsIOS =
  /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;

export default {
  debugConsole
};
